import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsGroupMarketingPreferencesFieldset extends FormFieldset {
  groupMarketingConsentField: FormField;
}
